import Product from '~/models/Product/Product'

export const minimizeProduct = (inputProduct: Product) => {
    if (inputProduct.type === 'catalog_banner') {
        return inputProduct
    }

    inputProduct = inputProduct as Product

    return {
        id: inputProduct.id,
        name: inputProduct.name,
        price: inputProduct.price,
        hasSuperPrice: inputProduct.hasSuperPrice,
        hasOpenersPrice: inputProduct.hasOpenersPrice,
        priceBeforeDiscount: inputProduct.priceBeforeDiscount,
        lowestPrice: inputProduct.lowestPrice,
        availabilityPeriod: inputProduct.availabilityPeriod,
        amountInStock: inputProduct.amountInStock,
        image: inputProduct.image,
        imageCdn: inputProduct.imageCdn,
        imageBySize: {
            imageCdn120: inputProduct.imageBySize.imageCdn120,
            imageCdn160: inputProduct.imageBySize.imageCdn160,
            imageCdn240: inputProduct.imageBySize.imageCdn240,
            imageCdn320: inputProduct.imageBySize.imageCdn320,
        },
        status: inputProduct.status,
        isAvailable: inputProduct.isAvailable,
        rate: inputProduct.rate,
        description: inputProduct.description,
        attributes: {
            addOnProducts: inputProduct.attributes.addOnProducts,
            machineLearningAddOnProducts: inputProduct.attributes.machineLearningAddOnProducts,
            addonSalePrice: inputProduct.attributes.addonSalePrice,
            // isInBonus: inputProduct.attributes.isInBonus,
            // isInTv: inputProduct.attributes.isInTv,
            isRecommended: inputProduct.attributes.isRecommended,
            // isRegulated: inputProduct.attributes.isRegulated,
            // isInAction: inputProduct.attributes.isInAction,
            // isFreeSale: inputProduct.attributes.isFreeSale,
            // isGift: inputProduct.attributes.isGift,
            // isGiftReward: inputProduct.attributes.isGiftReward,
            // hasFreeDelivery: inputProduct.attributes.hasFreeDelivery,
            // hasExtendedWarranty: inputProduct.attributes.hasExtendedWarranty,
            // isPilulkaCar: inputProduct.attributes.isPilulkaCar,
            // isPharmacyPickupAvailable: inputProduct.attributes.isPharmacyPickupAvailable,
            // isSoldByPharmacy: inputProduct.attributes.isSoldByPharmacy,
            // isFavorite: inputProduct.attributes.isFavorite,
            maxAmountPerOrder: inputProduct.attributes.maxAmountPerOrder,
            // isForAdultsOnly: inputProduct.attributes.isForAdultsOnly,
            // isCartSubstitutionsDisabled: inputProduct.attributes.isCartSubstitutionsDisabled,
            outOfStockGreyedOut: inputProduct.attributes.outOfStockGreyedOut,
            // isFreelyAvailableMedicine: inputProduct.attributes.isFreelyAvailableMedicine,
            // isDietarySupplement: inputProduct.attributes.isDietarySupplement,
            // isBreastFeeding: inputProduct.attributes.isBreastFeeding,
            comparablePrice: inputProduct.attributes.comparablePrice,
            hasCategoryComparablePriceSort: inputProduct.attributes.hasCategoryComparablePriceSort,
        },
        priceFrom: inputProduct.priceFrom,
        percentDiscount: inputProduct.percentDiscount,
        // percentDiscountAsString: inputProduct.percentDiscountAsString,
        availabilityText: inputProduct.availabilityText,
        availabilityTextColor: inputProduct.availabilityTextColor,
        isDeliveryPostponedForAmountInCart: inputProduct.isDeliveryPostponedForAmountInCart,
        visualTags: {
            merged: inputProduct.visualTags.merged.map((visualTag) => {
                return {
                    id: visualTag.id,
                    name: visualTag.name,
                    image: visualTag.image,
                    showInList: visualTag.showInList,
                    showOnProductDetail: visualTag.showOnProductDetail,
                    showAsBenefit: visualTag.showAsBenefit,
                    showAsImageOnly: visualTag.showAsImageOnly,
                    backgroundColor: visualTag.backgroundColor,
                    textColor: visualTag.textColor,
                    sort: visualTag.sort,
                    size: visualTag.size,
                }
            }),
        },
        // service: inputProduct.service,
        url: inputProduct.url,
        brandName: inputProduct.brandName,
        categoryNames: inputProduct.categoryNames,
        giftActions: inputProduct.giftActions,
        expirationDate: inputProduct.expirationDate,
        availabilityModalEnabled: inputProduct.availabilityModalEnabled,
        // subProducts: inputProduct.subProducts,
        pricePerPiece: inputProduct.pricePerPiece,
        productCodeSale: inputProduct.productCodeSale,
        mobileAppPrice: inputProduct.mobileAppPrice,
        mobileAppPriceForLoggedInUser: inputProduct.mobileAppPriceForLoggedInUser,
        // specialPriceText: inputProduct.specialPriceText,
        // itemType: inputProduct.itemType,
        variantsCount: inputProduct.variantsCount,
        // giftProductsText: inputProduct.giftProductsText,
        productRating: inputProduct.productRating,
        averageRating: inputProduct.averageRating,
        priceNoVat: inputProduct.priceNoVat,
        // originalPriceNoVat: inputProduct.originalPriceNoVat,
        hasCompetitorSuperPrice: inputProduct.hasCompetitorSuperPrice,
        cashbackLabel: inputProduct.cashbackLabel,
        manufacturerName: inputProduct.manufacturerName,
        isPreorder: inputProduct.isPreorder,
        hasMobileAppAction: inputProduct.hasMobileAppAction,
        pharmacyDealPrice: inputProduct.pharmacyDealPrice,
        pharmacyDealDescription: inputProduct.pharmacyDealDescription,
        premiumDealPrice: inputProduct.premiumDealPrice,
        premiumDealDescription: inputProduct.premiumDealDescription,
        lastItemsOnStockMessage: inputProduct.lastItemsOnStockMessage,
        packSizeHumanReadableValue: inputProduct.packSizeHumanReadableValue,
        isSponsored: inputProduct.isSponsored,
        vat: inputProduct.vat,
        isPremiumExclusive: inputProduct.isPremiumExclusive,
    } as Product
}
